import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home/home";
import "./scss/global.scss";
import Navbar from "./components/navbar/navbar";
import Footer from "./components/footer/footer";
import { gsap } from "gsap-trial";
import { ScrollTrigger } from "gsap-trial/ScrollTrigger";
import { useEffect } from "react";
import About from "./pages/about/about";
import Portfolio from "./pages/portfolio/portfolio";
import Estates from "./pages/estates/estates";
import Contact from "./pages/contact/contact";
import Units from "./pages/units/units";
import IntroAnimation from "./pages/animations/intro";
import MapPage from "./pages/map/map";
import PrivacyPolicy from "./pages/privacyPolicy/privacyPolicy";
import PageNotFound from "./pages/pageNotFound/pageNotFound";

gsap.registerPlugin(ScrollTrigger);

const App: React.FC = () => {
    const routes = [
        { path: "/", component: IntroAnimation },
        { path: "/home", component: Home },
        { path: "/about", component: About },
        { path: "/portfolio", component: Portfolio },
        { path:"/portfolio/:slug", component: Estates },
        { path:"/portfolio/:slug/:slug", component: Units },
        { path: "/contact", component: Contact },
        { path: "/map", component: MapPage },
        { path: "/privacy-policy", component: PrivacyPolicy },
        { path: "/*", component: PageNotFound },
    ];

    return (
        <>
            <BrowserRouter>
                <div id="smooth-wrapper">
                    <div id="smooth-content">
                        <Navbar />
                        <Routes>
                            {routes.map((route, index) => {
                                return (
                                    <Route
                                        key={index}
                                        path={route.path}
                                        element={<route.component />}
                                    />
                                );
                            })}
                        </Routes>
                        <Footer />
                    </div>
                </div>
            </BrowserRouter>
        </>
    );
};

export default App;
